import { render, staticRenderFns } from "./material.vue?vue&type=template&id=0129f212&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=0129f212&prod&lang=less&scoped=true"
import style1 from "./material.vue?vue&type=style&index=1&id=0129f212&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0129f212",
  null
  
)

export default component.exports